import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import FilterTableItem from 'components/FilterTableItem';
import ResponsiveImage from 'components/ResponsiveImage';
import LinkButton, { LINK_BUTTON_THEMES } from 'components/LinkButton';
import Link, { LINK_BEHAVIORS, LINK_THEMES } from 'components/Link';
import EmployeeType from 'types/EmployeeType';

import * as css from './EmployeeListItem.scss';

const EmployeeListItem = ({
  id,
  name,
  title,
  country,
  image,
  phone,
  secondaryPhone,
  phoneFormatted,
  secondaryPhoneFormatted,
  email,
  intro,
  bulletList,
  labels,
  hide,
}) => (
  <FilterTableItem colSpan={3} hide={hide} id={id} name={name} type="employee">
    <header className={css.header}>
      {image && (
        <div className={css.image}>
          <ResponsiveImage
            {...image}
            fluid
            loading="lazy"
            className={css.profileImage}
            sources={[
              {
                width: 180,
                height: 180,
              },
            ]}
          />
        </div>
      )}
      <div className={css.name}>
        <h3 className="h1">{name}</h3>
        <h4 className="lead">
          {title}
          <br />
          {country}
        </h4>
      </div>
    </header>
    <section className={css.info}>
      <div className={cn(css.intro, 'wysiwyg negative')}>
        <div dangerouslySetInnerHTML={{ __html: intro }} />
        {bulletList && (
          <ul>
            {bulletList.map(i => (
              <li key={i}>{i}</li>
            ))}
          </ul>
        )}
      </div>
      <div className={cn(css.contactText, 'wysiwyg', 'negative')}>
        <h4>{labels.contactInformation}</h4>
        {phone && (
          <Link
            url={`tel:${phoneFormatted}`}
            text={phone}
            theme={LINK_THEMES.lightTotal}
            behavior={LINK_BEHAVIORS.text}
          />
        )}
        <br />
        {secondaryPhone && (
          <Link
            url={`tel:${secondaryPhoneFormatted}`}
            text={secondaryPhone}
            theme={LINK_THEMES.lightTotal}
            behavior={LINK_BEHAVIORS.text}
          />
        )}
        <br />
        {email && (
          <Link
            url={`mailto:${email}`}
            text={email}
            theme={LINK_THEMES.lightTotal}
            behavior={LINK_BEHAVIORS.text}
          />
        )}
        <br />
        <br />
      </div>
      <div className={css.contactActions}>
        {phone && (
          <LinkButton
            url={`tel:${phoneFormatted}`}
            text={labels.callMe}
            theme={LINK_BUTTON_THEMES.darkFilled}
          />
        )}
        {email && (
          <LinkButton
            url={`mailto:${email}`}
            text={labels.sendEmail}
            theme={LINK_BUTTON_THEMES.outline}
          />
        )}
      </div>
    </section>
  </FilterTableItem>
);

EmployeeListItem.propTypes = {
  ...EmployeeType,
  labels: PropTypes.shape({
    callMe: PropTypes.string.isRequired,
    contactInformation: PropTypes.string.isRequired,
    sendEmail: PropTypes.string.isRequired,
  }).isRequired,
  hide: PropTypes.bool.isRequired,
};

export default EmployeeListItem;
